module.exports = __webpack_public_path__ + "static/media/logo.cdcc5424.png";